<template>
  <a-card :bordered="false">
    <div>
      <a-table
        :data-source="table.data"
        :columns="table.columns"
        :scroll="{ y: 'calc(100vh - 410px)' }"
        row-key="email"
        style="width: 100%">
        <template slot-scope="text, record" slot="action">
          <div class="table-operation-wrap">
<!--            <a-button type="link" @click="editTax(record.id)"> {{ $t('EDIT') || '编辑' }}</a-button>-->
            <a-button type="link" @click="deleteAppointment(record.id)"> {{ $t('DELETE') || '删除' }}</a-button>
          </div>
        </template>
      </a-table>
    </div>
  </a-card>
</template>

<script>
import { _queryNewsletter } from '@/api/websiteUserRequest';

async function getNewsletterList() {
  this.table.loading = true;
  let direction = this.table.sort.order;
  if (direction) {
    direction = direction === 'ascend' ? 'ASC' : 'DESC';
  }
  const result = await _queryNewsletter({
    page: this.table.pagination.current,
    size: this.table.pagination.pageSize,
    sort: this.table.sort.prop,
    direction,
  });
  this.table.data = result.content;
  this.table.pagination.total = result.totalElements;
  this.table.loading = false;
}

function closeForm() {
  this.form.data.id = null;
  this.form.visible = false;
}

const columns = [
  {
    title: '邮箱',
    dataIndex: 'email',
    scopedSlots: { customRender: 'email' },
  },
  {
    title: 'lastName',
    dataIndex: 'lastName',
    ellipsis: true,
    scopedSlots: { customRender: 'name' },
  },
  {
    title: 'firstName',
    dataIndex: 'firstName',
    scopedSlots: { customRender: 'location' },
  },
  {
    title: '操作',
    width: 300,
    scopedSlots: { customRender: 'action' },
  },
]
export default {
  name: 'WebsiteNewsletter',
  components: {},
  data() {
    return {
      searchForm: {
        data: {
          title: '',
          content: '',
          image: '',
        },
      },
      form: {
        data: {
          id: null,
        },
        visible: false,
      },
      table: {
        columns: columns,
        loading: false,
        data: [],
        pagination: {
          current: 1,
          pageSize: 10,
          total: 0,
        },
        sort: {
          prop: 'createAt',
          order: 'descending',
        },
      },
    };
  },
  methods: {
    getNewsletterList,
  },
  created() {
    this.getNewsletterList();
  },
};
</script>

<style scoped>

</style>
